import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectIsNotLoggedIn, selectUserHasPassword } from '../+state/auth.reducer';

export const notLoginGuard: CanActivateFn = async () => {
    const router = inject(Router);
    const store = inject(Store);
    const isNotLoggedIn = store.selectSignal(selectIsNotLoggedIn)();
    if (!isNotLoggedIn) {
        const hasPassword = store.selectSignal(selectUserHasPassword)();
        if (!hasPassword) {
            return true;
        }
        await router.navigateByUrl('/');
    }
    return isNotLoggedIn;
};
